/**
 * Execution Plan Workspace Type
 *
 * Registers the execution plan tab with the workspace registry.
 * Used for importing/opening plan files and plan compare workflows.
 */

import { registerWorkspaceComponent } from '../core/registry/workspaceRegistry';
import { lazyWorkspaceTab } from '../core/registry/lazyWorkspaceTab';

registerWorkspaceComponent(
  'plan',
  lazyWorkspaceTab(() => import('./components/ExecutionPlanTab').then((m) => ({ default: m.ExecutionPlanTab }))),
);


